import React from 'react'
import { colors } from '@material-ui/core'
import {
  Disc as DiscIcon,
  XCircle as XCircleIcon,
  DivideCircle as DivideCircleIcon,
  CheckCircle as CheckCircleIcon,
} from 'react-feather'

import palette from 'theme/palette'

const DENIED_KIND = 'denied'
const FULL_KIND = 'full'
const PARTIAL_KIND = 'partial'

const READING_TYPE_TRANSLATION = {
  [DENIED_KIND]: 'Recusado',
  [FULL_KIND]: 'Aceito',
  [PARTIAL_KIND]: 'Aceite parcial',
}

const STATUS_CHIP_COLOR = {
  [DENIED_KIND]: colors.red[100],
  [FULL_KIND]: colors.green[100],
  [PARTIAL_KIND]: colors.blue[100],
}

const STATUS_CHIP_FONT_COLOR = {
  [DENIED_KIND]: colors.red[800],
  [FULL_KIND]: colors.green[800],
  [PARTIAL_KIND]: colors.blue[800],
}

const DEVICE_LABELS = {
  mobile: 'Mobile',
  tablet: 'Tablet',
  desktop: 'Desktop',
  unidentified: 'Não identificado',
}

const DEVICE_TABLET_REGEX =
  /iPad|Tablet|Kindle|Silk|PlayBook|(?=.*Android)(?!.*Mobile)/i
const DEVICE_MOBILE_REGEX =
  /Mobile|iPhone|iPod|Android|Windows Phone|BlackBerry|Opera Mini|IEMobile/i
const DEVICE_DESKTOP_REGEX = /Windows NT|Macintosh|Mac OS X|X11|CrOS|Linux/i

const CONSENT_DETAILS_DIALOG_ITEMS = [
  {
    title: 'Nome do banner',
    value: (value) => value,
  },
  {
    title: 'UserAgent',
    value: (value) => value,
  },
  {
    title: 'Origem de acesso',
    value: (value) => value,
  },
  {
    title: 'Tipo:',
    value: (value) => value,
  },
  {
    title: 'Data do consentimento:',
    value: (value) => value,
  },
  {
    title: 'Tags aceitas:',
    value: (value) => value,
  },
  {
    title: 'Tags recusadas',
    value: (value) => value,
  },
  {
    title: 'Menor de idade:',
    value: (value) =>
      value === null
        ? 'Controle de idade não habilitado'
        : value
        ? 'Sim'
        : 'Não',
  },
]

const COOKIES_CONSENT_MAIN_DRIVER_STEP = 'cookies-consent-main-driver-step'
const COOKIES_CONSENT_FILTERS_DRIVER_STEP =
  'cookies-consent-filters-driver-step'
const COOKIES_CONSENT_CARDS_DRIVER_STEP = 'cookies-consent-cards-driver-step'
const COOKIES_CONSENT_TABLE_DRIVER_STEP = 'cookies-consent-table-driver-step'

const COOKIES_CONSENT_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COOKIES_CONSENT_MAIN_DRIVER_STEP,
    popover: {
      title: 'Consentimentos de Cookies',
      description:
        'Área destinada à exibição das interações dos usuários com o banner de cookies. Aqui é possível verificar se o consentimento foi concedido total ou parcialmente, bem como identificar quais categorias de cookies (tags) foram aceitas ou recusadas.',
    },
  },
  {
    element: '#' + COOKIES_CONSENT_FILTERS_DRIVER_STEP,
    popover: {
      title: 'Filtros',
      description:
        'É possível aplicar filtros por data do consentimento, nome do banner e URL, facilitando a análise e a localização de registros específicos.',
    },
  },
  {
    element: '#' + COOKIES_CONSENT_CARDS_DRIVER_STEP,
    popover: {
      title: 'Estatísticas',
      description:
        'Aqui mostra a quantidade de banners e a quantidade de consentimento registrado.',
    },
  },
  {
    element: '#' + COOKIES_CONSENT_TABLE_DRIVER_STEP,
    popover: {
      title: 'Tabela de Consentimentos',
      description:
        'Visualize um resumo dos dados registrados no consentimento de cookies. Para mais detalhes, clique no ícone de três pontos e selecione "Ver Detalhes".',
    },
  },
]

const STATS_CARDS_CONFIG = [
  {
    key: 'bannersCount',
    kind: null,
    icon: <DiscIcon size={24} />,
    label: 'BANNERS COM CONSENTIMENTOS',
    backgroundColor: palette.subscription.primary.main,
  },
  {
    key: 'fullCount',
    kind: FULL_KIND,
    icon: <CheckCircleIcon size={24} />,
    label: 'CONSENTIMENTOS ACEITOS',
    backgroundColor: palette.statuses.approved,
  },
  {
    key: 'deniedCount',
    kind: DENIED_KIND,
    icon: <XCircleIcon size={24} />,
    label: 'CONSENTIMENTOS RECUSADOS',
    backgroundColor: palette.statuses.disapproved,
  },
  {
    key: 'partialCount',
    kind: PARTIAL_KIND,
    icon: <DivideCircleIcon size={24} />,
    label: 'CONSENTIMENTOS PARCIAIS',
    backgroundColor: palette.statuses.pending,
  },
]

export default {
  READING_TYPE_TRANSLATION,
  CONSENT_DETAILS_DIALOG_ITEMS,
  DEVICE_LABELS,
  DEVICE_TABLET_REGEX,
  DEVICE_MOBILE_REGEX,
  DEVICE_DESKTOP_REGEX,
  STATUS_CHIP_COLOR,
  STATUS_CHIP_FONT_COLOR,
  COOKIES_CONSENT_DRIVER_STEPS_OBJECT,
  COOKIES_CONSENT_MAIN_DRIVER_STEP,
  COOKIES_CONSENT_FILTERS_DRIVER_STEP,
  COOKIES_CONSENT_CARDS_DRIVER_STEP,
  COOKIES_CONSENT_TABLE_DRIVER_STEP,
  STATS_CARDS_CONFIG,
}
